// extracted by mini-css-extract-plugin
export default {"message":"Message_message__thqKW","avatar":"Message_avatar__pAC92","content":"Message_content__-jepp","name":"Message_name__IWjH5","time":"Message_time__9d827"};